import React from 'react'

const StatCard = ({ title, value, change, changeType = 'neutral', icon: Icon, iconColor = 'bg-primary' }) => {
  const getChangeColor = () => {
    switch(changeType) {
      case 'positive': return 'text-success'
      case 'negative': return 'text-danger'
      default: return 'text-muted'
    }
  }

  return (
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <p className="text-muted mb-1 small fw-medium">{title}</p>
            <h3 className="mb-0 fw-bold">{value}</h3>
            {change && (
              <small className={`${getChangeColor()} mt-2 d-block`}>
                {change}
              </small>
            )}
          </div>
          <div className={`${iconColor} rounded p-3 d-flex align-items-center justify-content-center`}>
            <Icon size={24} color="white" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatCard